// extracted by mini-css-extract-plugin
module.exports = {"btn":"Pagination_btn__y47GB"};